<template>
    <div>
        <FullPageLoader :isLoading="loading"/>

        <b-modal :active.sync="showSavePromptModal" id="savepromptmodal" aria-modal :width="600" :can-cancel="false">
            <div class="modal-card" style="width: auto">
                <b-loading :active.sync="loading" :is-full-page="false"></b-loading>

                <header class="modal-card-head"><p class="modal-card-title">Bevestigen</p></header>

                <section class="modal-card-body" style="overflow: hidden;border-radius:0;">
                    <p>{{ formattedPromptText }}</p>
                </section>

                <footer class="modal-card-foot text-right">
                    <button class="button" type="button" @click="showSavePromptModal = false" :loading="loading">Annuleren</button>
                    <button class="button is-success" @click="save" :loading="loading">Bevestigen</button>
                </footer>
            </div>
        </b-modal>

        <b-modal :active.sync="showEmailPromptModal" id="emailpromptmodal" aria-modal :width="600" :can-cancel="false">
            <div class="modal-card" style="width: auto">
                <header class="modal-card-head"><p class="modal-card-title">Prijswijziging doorgevoerd</p></header>

                <section class="modal-card-body" style="overflow: hidden;border-radius:0;">
                    <p>Wil je de <span v-if="one">klant</span><span v-else>klanten</span> een e-mail sturen over deze prijswijziging?</p>
                </section>

                <footer class="modal-card-foot text-right">
                    <b-button @click="cancelEmailing">Annuleren</b-button>
                    <b-button type="is-success" @click="goToMailRecord">{{ one ? 'Klant' : 'Klanten' }} mailen</b-button>
                </footer>
            </div>
        </b-modal>

        <!-- Progress modal for processing cronjobs -->
        <b-modal :active.sync="showProgressModal" id="progressmodal" aria-modal :width="500" :can-cancel="false">
            <div class="modal-card" style="width: auto">
                <header class="modal-card-head">
                    <p class="modal-card-title">
                        Facturen genereren
                    </p>
                </header>

                <section class="modal-card-body" style="overflow: hidden;border-radius:0;">
                    <div class="has-text-centered">
                        <p class="mb-4">
                            <strong>Factuur {{ currentCronjobIndex }} van {{ totalCronjobs }}</strong>
                        </p>

                        <b-progress
                            :value="progressPercentage"
                            size="is-medium"
                            :type="progressType"
                            show-value
                        >
                            {{ progressPercentage }}%
                        </b-progress>

                        <p class="mt-4 has-text-grey" v-if="processingCronjobs">
                            <small>Je kunt deze pagina verlaten.<br>De facturen worden dan op de achtergrond verder verwerkt.</small>
                        </p>

                        <p class="mt-4 has-text-success text-with-icon" v-if="!processingCronjobs && cronjobsCompleted">
                            <b-icon icon="check-circle"></b-icon>
                            Alle facturen zijn succesvol gegenereerd!
                        </p>

                        <p class="mt-4 has-text-danger text-with-icon" v-if="cronjobErrors.length > 0">
                            <b-icon icon="exclamation-triangle"></b-icon>
                            {{ cronjobErrors.length }} factuur(en) konden niet worden gegenereerd.
                        </p>
                    </div>
                </section>

                <footer class="modal-card-foot text-right">
                    <b-button
                        v-if="processingCronjobs"
                        type="is-light"
                        @click="leaveProcessing"
                    >
                        Op achtergrond verwerken
                    </b-button>
                    <b-button
                        v-else
                        type="is-success"
                        @click="finishProcessing"
                    >
                        Doorgaan
                    </b-button>
                </footer>
            </div>
        </b-modal>

        <div class="row">
            <div class="column medium-3 text-right float-right">
                <b-button tag="router-link" :to="{ name: 'ContractsPriceChanges' }" type="is-dark">Terug naar overzicht</b-button>
            </div>
            <div class="column medium-9">
                <div class="title-wrap">
                    <h1 class="marginbottom10">{{ type == 'new' ? 'Prijswijziging(en) aanmaken' : `Prijswijziging van ${_.has(record, 'date_from') ? moment(record.date_from).format('DD-MM-YYYY') : ''}` }}</h1>
                    <p class="description"">Momenteel wordt deze functie enkel gebruikt om de prijzen van boxen te verhogen/verlagen binnen contracten.</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="column">
                <form class="form">
                    <b-tabs size="is-medium" class="block" v-model="tabIndex">
                        <b-tab-item label="Algemeen">
                            <div class="row" v-if="user && user.role == 'pit' && $store.state.env === 'local'">
                                <div class="column">
                                    <b-field label="Organisatie (PIT) - Local only"
                                        :message="getError(errors, 'organisation')"
                                        :type="getType(errors, 'organisation', '')"
                                    >
                                        <span>
                                            <b-select placeholder="Selecteer een organisatie" v-model="record.organisation" expanded>
                                                <option
                                                    v-for="organisation in organisations"
                                                    :value="organisation.id"
                                                    :key="'organisatie_'+organisation.id"
                                                >(ID: {{ organisation.id }}) {{ organisation.name }}</option>
                                            </b-select>
                                        </span>
                                    </b-field>
                                </div>
                            </div>

                            <!-- Temp disabled, we only have one option yet (boxes) -->
                            <!-- <b-field :label="`Prijswijzigen in ${one ? 'contract' : 'contracten'}`"
                                :message="getError(errors, 'mutate')"
                                :type="getType(errors, 'mutate', '')"
                            >
                                <span>
                                    <b-select placeholder="Maak een keuze" v-model="record.mutate" expanded>
                                        <option value="boxes">Boxen</option>
                                        <option value="products" disabled>Producten (nog niet mogelijk)</option>
                                        <option value="boxes_products" disabled>Boxen en producten (nog niet mogelijk)</option>
                                    </b-select>
                                </span>
                            </b-field> -->

                            <div v-if="_.has(record, 'extra')">
                                <slide-up-down :active="record.mutate == 'boxes' || record.mutate == 'boxes_products'" :duration="500">
                                    <h6>Wijzigingen buiten contracten</h6>
                                    <b-field>
                                        <b-checkbox v-model="record.extra.update_box_price">Prijzen van de boxen óók wijzigen (voor toekomstige contracten).</b-checkbox><br>
                                    </b-field>

                                    <b-field>
                                        <b-checkbox v-model="record.extra.update_box_deposit">Borg van de boxen óók wijzigen (voor toekomstige contracten).</b-checkbox>
                                    </b-field>
                                    <br>
                                </slide-up-down>
                            </div>

                            <b-field label="Prijs positief of negatief aanpassen"
                                :message="getError(errors, 'min_plus')"
                                :type="getType(errors, 'min_plus', '')"
                            >
                                <span>
                                    <b-select placeholder="Maak een keuze" v-model="record.min_plus" expanded>
                                        <option value="plus">Positief - De prijs gaat omhoog</option>
                                        <option value="min">Negatief - De prijs gaat omlaag</option>
                                    </b-select>
                                </span>
                            </b-field>

                            <b-field label="Type wijziging"
                                :message="getError(errors, 'type')"
                                :type="getType(errors, 'type', '')"
                            >
                                <span>
                                    <b-select placeholder="Selecteer een type" v-model="record.type" expanded>
                                        <option value="euro">Bedrag</option>
                                        <option value="perc">Percentage</option>
                                    </b-select>
                                </span>
                            </b-field>

                            <b-field :label="`${record.type == 'euro' ? 'Prijs' : 'Procent' } (${formatPrice})`"
                                :message="getError(errors, 'price')"
                                :type="getType(errors, 'price', '')"
                            >
                                <b-input v-model="record.price"></b-input>
                            </b-field>

                            <b-field label="Prijswijziging vanaf (factuur datum)"
                                :message="getError(errors, 'date_from')"
                                :type="getType(errors, 'date_from', '')"
                            >
                                <b-datepicker
                                    placeholder="Klik om te selecteren"
                                    :nearby-selectable-month-days="true"
                                    icon="calendar-alt"
                                    icon-pack="fas"
                                    :min-date="moment(new Date()).startOf('day').toDate()"
                                    v-model="record.date_from"
                                    v-if="type == 'new'"
                                />
                                <span v-else>
                                    {{ moment(record.date_from).format('DD-MM-YYYY') }}
                                </span>
                            </b-field>

                            <b-field label="Voor contracten actief op datum"
                                :message="getError(errors, 'date_active')"
                                :type="getType(errors, 'date_active', '')"
                                v-if="!one"
                            >
                                <b-datepicker
                                    placeholder="Klik om te selecteren"
                                    :nearby-selectable-month-days="true"
                                    icon="calendar-alt"
                                    icon-pack="fas"
                                    v-model="record.date_active"
                                    v-if="type == 'new'"
                                />
                                <span v-else>
                                    {{ moment(record.date_active).format('DD-MM-YYYY') }}
                                </span>
                            </b-field>

                            <slide-up-down :active="type === 'new' && !!earlier_price_changes.length" v-if="type === 'new' && !one">
                                <b-field label="Exclusief eerdere prijswijzigingen (optioneel)"
                                    :message="getError(errors, 'exclude_ids')"
                                    :type="getType(errors, 'exclude_ids', '')"
                                >
                                    <b-select placeholder="Maak een keuze (optioneel)" v-model="record.exclude_ids" expanded>
                                        <option :value="null">Geen</option>
                                        <option :value="earlier.id" v-for="earlier in earlier_price_changes" >
                                            Prijswijziging van {{ moment(earlier.date_from).format('DD-MM-YYYY') }} (Mutaties: {{ earlier.affected_count }})
                                        </option>
                                    </b-select>
                                </b-field>
                            </slide-up-down>
                            <div v-else-if="type === 'view' && !!record.exclude_ids">
                                <div class="field">
                                    <label class="label">Exclusief eerdere prijswijzigingen (optioneel)</label>
                                    <p>
                                        Prijswijziging van {{ moment(earlier_price_changes.date_from).format('DD-MM-YYYY') }} (Mutaties: {{ earlier_price_changes.affected_count }})&nbsp;<b-button type="is-dark" size="is-small" tag="router-link" :to="{ name: 'ContractsPriceChangesRecord', params: {id: earlier_price_changes.id} }">Bekijken</b-button>
                                    </p>
                                </div>
                            </div>
                        </b-tab-item>

                        <b-tab-item :label="one ? 'Contract' : 'Contracten'">
                            <h3>{{ one ? 'Contract' : 'Contracten' }}</h3>
                            <p v-if="type == 'new'">
                                <span v-if="!one">
                                    Controleer of onderstaande contracten meegenomen mogen worden in de prijswijziging.<br>
                                    <br>
                                </span>
                                De prijzen in de ingeplande facturen worden alleen aangepast wanneer er nog geen factuur gestuurd is, of als er nog geen incasso opdracht verzonden is.
                                Wanneer de bedragen in de ingeplande facturen aangepast moeten worden, dan worden de ingeplande facturen geannuleerd en daarna automatisch opnieuw aangemaakt met de nieuwe bedragen binnen enkele minuten.
                            </p>
                            <p v-else>{{ one ? 'Onderstaand contract is' : 'Onderstaande contracten zijn' }} meegenomen in de prijswijziging.</p>

                            <!-- {{ contracts }} -->
                            <b-table
                                :data="contracts"
                                :checked-rows.sync="selectedContracts"
                                :checkable="type == 'new'"
                                :detailed="type == 'view'"

                                :show-detail-icon="type == 'view'"
                                :sticky-header="true"
                                checkbox-position="left"
                                checkbox-type="is-primary"
                                :striped="true"
                                :loading="loading"
                                :mobile-cards="true"
                                class="contract-price-change-table"

                                :backend-pagination="type == 'view'"
                                :total="total"
                                :paginated="paginated"
                                :per-page="perPage"

                                @page-change="onPageChange"
                            >
                                <template>
                                    <b-table-column v-slot="props" field="organisation" label="Org." width="50" :visible="user && user.role == 'pit' && $store.state.dataBelongsTo === 'all'" class="admin">
                                        <b-button type="is-primary" outlined tag="router-link" size="is-small" :to="{ name: 'OrganisationsRecord', params: {id: props.row.organisation} }" v-if="user && user.role == 'pit'">
                                            {{ _.has(organisations, props.row.organisation) ? organisations[props.row.organisation].short_name : '-' }}
                                        </b-button>
                                    </b-table-column>

                                    <b-table-column v-slot="props" field="customer.type" label="Type">
                                        {{ props.row.customer.type == 'normal' ? 'Particulier' : props.row.customer.type == 'business' ? 'Zakelijk' : props.row.customer.type == 'foundation' ? 'Stichting' : props.row.customer.type }}
                                    </b-table-column>

                                    <b-table-column v-slot="props" field="customer" label="Klant">
                                        <b-button type="is-text" size="is-small" class="text-left" v-if="props.row.customer">
                                            {{ props.row.customer.firstname }}&nbsp;{{ props.row.customer.lastname }}
                                            <span v-if="!_.isNull(props.row.customer.companyname) && (props.row.customer.type == 'business' || props.row.customer.type == 'foundation')" :icon="!_.isNull(props.row.customer.companyname) && (props.row.customer.type == 'business' || props.row.customer.type == 'foundation') ? 'building' : 'people'">
                                                <br>
                                                <strong>
                                                    <span v-if="props.row.customer.companyname.length >= 27">
                                                        <b-tooltip :label="props.row.customer.companyname" position="is-top">
                                                            {{ props.row.customer.companyname|truncate(25, '..') }}
                                                        </b-tooltip>
                                                    </span>
                                                    <span v-else>{{ props.row.customer.companyname }}</span>
                                                </strong>
                                            </span>
                                        </b-button>
                                        <span v-else>-</span>
                                    </b-table-column>

                                    <b-table-column v-slot="props" field="payment_type" label="Betaalmethode">
                                        <span>{{ props.row.payment_type == 'incasso' ? 'Incasso' : props.row.payment_type == 'manual' ? 'Handmatig' : props.row.payment_type }}</span>
                                    </b-table-column>

                                    <b-table-column v-slot="props" field="start_date" label="Start" width="180">
                                        <span>{{ props.row.start_date|humanDate }}</span>
                                    </b-table-column>

                                    <b-table-column v-slot="props" field="end_date" label="Eind" width="180">
                                        <span v-if="!_.isNull(props.row.end_date)">{{ props.row.end_date|humanDate }}</span>
                                        <span v-else>-</span>
                                    </b-table-column>

                                    <b-table-column v-slot="props" numeric width="100" :visible="type == 'view'">
                                        <b-button tag="router-link" type="is-dark" size="is-small" :to="{ name: 'ContractsRecordView', params: {id: props.row.id} }">Bekijken</b-button>
                                    </b-table-column>
                                </template>

                                <template #bottom-left>
                                    <span v-show="type == 'new'">
                                        <strong>Totaal geselecteerd</strong>: {{ selectedContracts.length }}/{{ contracts.length }}
                                    </span>
                                </template>

                                <template #detail="props">
                                    <b-table
                                        :data="_.has(props.row, 'contract_price_change_prods') ? props.row.contract_price_change_prods : [props.row]"
                                        :striped="true"
                                        :loading="loading"
                                        :mobile-cards="true"
                                    >
                                        <b-table-column v-slot="props" field="prodtype" label="Type" width="160">
                                            {{ props.row.prodtype == 'box' ? 'Box' : props.row.prodtype == 'product' ? 'Product' : props.row.prodtype }}
                                        </b-table-column>
                                        <b-table-column v-slot="props" field="name" :label="props.row.type == 'box' ? 'Nmr.' : 'Naam'">
                                            {{ props.row.name }}
                                        </b-table-column>

                                        <b-table-column v-slot="props" field="old_price" label="Oude prijs" width="180">
                                            &nbsp;€&nbsp;{{ props.row.old_price }}
                                        </b-table-column>

                                        <b-table-column v-slot="props" field="new_price" label="Nieuwe prijs" width="180">
                                            &nbsp;€&nbsp;{{ props.row.new_price }}
                                        </b-table-column>

                                        <b-table-column v-slot="props" numeric width="100">
                                            <b-button tag="router-link" type="is-dark" size="is-small" :to="{ name: (props.row.prodtype == 'box' ? 'BoxesRecord' : 'ProductsRecord'), params: {id: props.row.product} }">Bekijken</b-button>
                                        </b-table-column>

                                        <!--
                                        <b-table-column v-slot="props" field="total_price" label="Totaal" width="180">
                                            <span v-if="hideSensitiveData">&euro;&nbsp;********</span>
                                            <span v-else-if="creditInvoice.row.total" class="text-danger">-&nbsp;€ {{ creditInvoice.row.total }}</span>
                                            <span v-else>-</span>
                                        </b-table-column>

                                        <b-table-column v-slot="props" field="send_at" label="Verstuurd" width="180">
                                            {{ creditInvoice.row.send_at || 'Nee' }}
                                        </b-table-column>

                                        <b-table-column v-slot="props" numeric width="100">
                                            <b-button tag="router-link" type="is-dark" size="is-small" :to="{ name: 'InvoicesRecord', params: {type: 'credit', id: creditInvoice.row.id} }">Bekijken</b-button>
                                        </b-table-column> -->
                                    </b-table>
                                </template>

                                <template #empty>
                                    <section class="section">
                                        <div class="content has-text-grey has-text-centered">
                                            <p class="margin0" v-if="loading === false">Geen prijswijzigingen gevonden.</p>
                                            <p class="margin0" v-else>Laden...</p>
                                        </div>
                                    </section>
                                </template>
                            </b-table>
                        </b-tab-item>

                    </b-tabs>
                </form>
            </div>
        </div>

        <slide-up-down :active="type == 'new'" :duration="500">
            <div class="row">
                <div class="column text-right">
                    <div class="formfooter">
                        <b-button type="is-light" :loading="loading" @click="tabIndex = 0" v-if="tabIndex > 0">Vorige stap</b-button>
                        <b-button type="is-success" :loading="loading" @click="tabIndex == 0 ? validateStep() : savePrompt()">{{ tabIndex == 0 ? 'Volgende stap' : 'Bevestigen' }}</b-button>
                    </div>
                </div>
            </div>
        </slide-up-down>
    </div>
</template>

<script>
import formvalidationMixin from '@/mixins/formvalidationMixin.js'
import toastMixins from '@/mixins/toastMixins.js'
import filtersMixin from '@/mixins/filterMixins'
import paramsMixin from '@/mixins/paramsMixin'

export default {
    name: 'ContractPriceChangesRecord',

    mixins: [formvalidationMixin, toastMixins, filtersMixin, paramsMixin],

    data () {
        return {
            type: 'new',
            one: false, // Updating one?
            showSavePromptModal: false,
            showEmailPromptModal: false,
            showProgressModal: false,
            newPriceChangeId: null,
            tabIndex: 0,
            total: 0,
            page: 1,
            perPage: 35,
            record: {},
            loading: false,
            errors: {},
            // Tab 2 - Contracts
            contracts: [],
            selectedContracts: [],
            earlier_price_changes: [],
            // Cronjob processing state
            cronjobIds: [],
            currentCronjobIndex: 0,
            totalCronjobs: 0,
            processingCronjobs: false,
            cronjobsCompleted: false,
            cronjobErrors: []
        }
    },

    computed: {
        formatPrice(){
            return this.record.price && parseInt(this.record.price) > 0 ? (this.record.type == 'euro' ? '€ ' : '')+Number.parseFloat(this.record.price).toFixed(2)+(this.record.type == 'euro' ? '' : '%') : (this.record.type == 'euro' ? '€ ' : '')+Number.parseFloat(0).toFixed(2)+(this.record.type == 'euro' ? '' : '%')
        },
        paginated(){
            return this.contracts.length < this.total
        },
        user() {
            return this.$store.state.user
        },
        organisations() {
            return this.$store.state.organisations ? this.$store.state.organisations : null
        },
        formattedPromptText(){
            return `Weet je zeker dat je voor ${this.selectedContracts.length} contract${this.selectedContracts.length > 1 ? 'en' : '' } een prijswijzing wil doorvoeren voor ${this.record.min_plus == 'min' ? '-' : '+'}${this.formatPrice} vanaf ${moment(this.record.date_from).format('DD-MM-YYYY')}?`
        },
        progressPercentage() {
            if (this.totalCronjobs === 0) return 0
            return Math.round((this.currentCronjobIndex / this.totalCronjobs) * 100)
        },
        progressType() {
            if (this.cronjobErrors.length > 0) return 'is-warning'
            if (this.cronjobsCompleted) return 'is-success'
            return 'is-primary'
        }
    },

    created () {
        // DEV DEBUG
        // this.record = {
        //     "organisation": 5,
        //     "mutate": "boxes",
        //     "extra": {
        //         "update_box_price": false,
        //         "update_box_deposit": false
        //     },
        //     "type": "euro",
        //     "min_plus": "plus",
        //     "price": "15",
        //     // "date_from": moment(new Date()).startOf('day').toDate(),
        //     // "date_active": moment(new Date()).startOf('year').toDate()
        // }
        // this.tabIndex = 1

        if(this.$route.params.id == 'nieuw'){
            if(_.has(this.$route, 'query.contract')){
                this.one = this.$route.query.contract
            }

            this.perPage = 999999 // no pagination

            this.record = {
                organisation: this.user.organisation,
                mutate: 'boxes', // default
                type: 'perc',
                min_plus: 'plus',
                extra: {
                    update_box_price: false,
                    update_box_deposit: false
                },
                date_from: moment(new Date()).startOf('day').toDate(),
                date_active: moment(new Date()).startOf('year').toDate()
            }

            this.fetchAllPriceChanges()
        } else if (this.$route.params.id){
            this.type = 'view'

            this.getSearchParams().then(() => {
                this.fetchRecord()
            })
        }
    },

    methods: {
        fetchRecord(){
            console.log('[🔥] Fetch contract price change', this.$route.params)
            // Set filter params & admin params
            const params = this.setParams(this.searchParams, 'ContractPriceChangesRecordView')
            this.loading = true

            axios.get('/api/contractpricechange/'+this.$route.params.id+'?'+params, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                // Set contracts (paginated if view)
                this.contracts = this.view == 'new' ? response.data.affected : response.data.affected.data
                this.total = this.view == 'new' ? 999999 : response.data.affected.total

                // Only one contract
                if(response.data.affected.length == 1){
                    this.one = response.data.affected[0].id
                }

                delete response.data.affected

                // Select all contracts (if new)
                if(this.view == 'new'){
                    _.each(this.contracts, (contract) => {
                        this.selectedContracts.push(contract)
                    })
                }

                this.$set(this, 'record', response.data)

                setTimeout(() => {
                    if(response.data.exclude_ids) {
                        this.fetchAllPriceChanges(response.data.exclude_ids)
                    }
                }, 250)
            }).catch((error) => {
                console.error('[❌] Error while price change:', error)
            }).then(() => {
                this.loading = false
            })
        },

        fetchAllPriceChanges(id = false) {
            if (!this.record.organisation && this.type === 'new') return;
            this.loading = true;

            if(this.type === 'new'){
                this.record.exclude_ids = null
            }

            axios.get(`/api/contractpricechange${id ? '/'+id : ''}?organisation=${this.record.organisation}`, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                if(this.type === 'new') {
                    this.earlier_price_changes = response.data.data;
                } else {
                    this.earlier_price_changes = response.data
                }
                this.loading = false;
            }).catch((error) => {
                console.error('[❌] Error while fetching price changes:', error);
                this.loading = false;
            });
        },

        validateStep(){
            this.loading = true
            this.selectedContracts = []

            axios.post(`/api/contractpricechange/validate${ this.one ? '?contract='+this.one : '' }`, this.record, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                // No results
                if(!response.data.length){
                    this.loading = false

                    return this.$buefy.toast.open({
                        message: 'Geen contracten gevonden binnen de gekozen selectie',
                        type: 'is-danger'
                    })
                }

                this.tabIndex = 1
                this.contracts = response.data

                // Select all contracts
                _.each(this.contracts, (contract) => {
                    this.selectedContracts.push(contract)
                })

                this.errors = {}
                this.loading = false
            }).catch((error) => {
                if(_.has(error, 'response.data.error') && error.response.data.error == 'not-org-admin'){
                    this.showError('Opslaan niet mogelijk, enkel een administrator is gemachtigd om prijswijzigingen aan te maken.')
                } else {
                    this.$buefy.toast.open({
                        message: 'Onvoldoende of onjuiste gegevens',
                        type: 'is-danger'
                    })

                    this.errors = {...error.response.data.errors}
                }
                this.tabIndex = 0
                this.loading = false
            })
        },

        savePrompt(){
            this.showSavePromptModal = true
        },

        save() {
            this.loading = true

            // Pass the selected contracts
            let sendData = JSON.parse(JSON.stringify(this.record))
            const contracts = _.map(this.selectedContracts, 'id')
            sendData.contracts = contracts

            axios.post('/api/contractpricechange/new', sendData, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.loading = false
                this.showSavePromptModal = false
                this.newPriceChangeId = response.data.pricechange_id

                // Check if there are cronjobs to process
                if (response.data.cronjob_ids && response.data.cronjob_ids.length > 0) {
                    this.cronjobIds = response.data.cronjob_ids
                    this.totalCronjobs = response.data.total_cronjobs
                    this.currentCronjobIndex = 0
                    this.cronjobsCompleted = false
                    this.cronjobErrors = []
                    this.showProgressModal = true
                    this.processCronjobs()
                } else {
                    // No cronjobs to process, go directly to email prompt
                    this.showEmailPromptModal = true
                }
            }).catch((error) => {
                if(_.has(error, 'response.data.error') && error.response.data.error == 'not-org-admin'){
                    this.showError('Opslaan niet mogelijk, enkel een administrator is gemachtigd om prijswijzigingen aan te maken.')
                } else {
                    this.$buefy.toast.open({
                        message: 'Daar gaat iets fout! Probeer het opnieuw.',
                        type: 'is-danger'
                    })

                    this.errors = {...error.response.data.errors}
                }

                this.tabIndex = 0
                this.loading = false
                this.showSavePromptModal = false
            })
        },

        async processCronjobs() {
            this.processingCronjobs = true

            for (let i = 0; i < this.cronjobIds.length; i++) {
                this.currentCronjobIndex = i + 1

                try {
                    await axios.post(`/api/cronjob/${this.cronjobIds[i]}/execute`, {}, {
                        headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
                    })
                } catch (error) {
                    console.error(`[❌] Error executing cronjob ${this.cronjobIds[i]}:`, error)
                    this.cronjobErrors.push({
                        id: this.cronjobIds[i],
                        error: error.response?.data?.error || 'Unknown error'
                    })
                }

                // Small delay between requests to prevent server overload
                if (i < this.cronjobIds.length - 1) {
                    await new Promise(resolve => setTimeout(resolve, 100))
                }
            }

            this.processingCronjobs = false
            this.cronjobsCompleted = true
        },

        leaveProcessing() {
            // User wants to leave - cronjobs will be processed by CommunicationShift
            this.showProgressModal = false
            this.showEmailPromptModal = true

            this.$buefy.toast.open({
                message: 'Facturen worden op de achtergrond verwerkt.',
                type: 'is-info',
                duration: 4000
            })
        },

        finishProcessing() {
            this.showProgressModal = false
            this.showEmailPromptModal = true
            // this.$router.push({name: 'ContractsPriceChanges'})
        },

        onPageChange(page) {
            this.page = page
            this.fetchRecord()
        },

        cancelEmailing() {
            this.showEmailPromptModal = false
            this.$router.push({name: 'ContractsPriceChanges'})
        },

        goToMailRecord() {
            this.showEmailPromptModal = false
            this.$router.push({
                name: 'MailRecord',
                params: { id: 'nieuw' },
                query: { pricechange: this.newPriceChangeId }
            })
        }
    },

    watch: {
        tabIndex(newVal, oldVal){
            if(newVal == 1 && oldVal != 1 && this.type == 'new'){
                this.validateStep()
            }
        },

        'record.organisation': {
            handler(newVal, oldVal){
                if(this.type == 'new' && !!newVal){
                    this.fetchAllPriceChanges()
                } else if (!newVal) {
                    this.earlier_price_changes = []
                }
            }
        },

        // Mutation changed, uncheck all!
        'record.mutate': {
            handler(newVal, oldVal){
                if(newVal !== oldVal && this.type == 'new'){
                    _.each(this.record.extra, (value, key) => {
                        this.record.extra[key] = false
                    })
                }
            }
        }
    }
}

</script>

<style scoped>
.text-with-icon {
    display:flex;
    justify-content: center;
}
</style>
